import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import s from './IconButton.scss';
import styleDS from './IconButton.icon_button_ds.scss';
var IconButton = function (_a) {
    var size = _a.size, className = _a.className, IconComponent = _a.icon, _b = _a.variant, variant = _b === void 0 ? 'main' : _b, props = __rest(_a, ["size", "className", "icon", "variant"]);
    var style = useFlag('icon_button_ds') ? styleDS : s;
    return (React.createElement(PlainButtonOrLink, __assign({ className: classnames(className, style['root'], style["size-" + size], variant && style["variant-" + variant], props.disabled && style['disabled']) }, props),
        React.createElement(IconComponent, { className: style['icon'], size: size === 'small' ? IconSize.SMALLER : IconSize.MEDIUM, disableDefaultColors: true })));
};
IconButton.displayName = 'IconButton';
export default IconButton;
//# sourceMappingURL=IconButton.js.map